(function () {
    'use strict';

    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {

        $stateProvider
            .state('profile', {
                url: "/:langcode/account",
                templateUrl: 'app/profile/profile.html',
                controller: 'ProfileController',
                abstract: true,
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'profile');
                    }],
                    guard: [
                        'guardSvc',
                        function (guardSvc) {
                            return guardSvc.guardRoute();
                        }
                    ],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('menu_profile');
                        $translatePartialLoader.addPart('profile_account');
                        return $translate.refresh();
                    }]
                }
            })
            .state('profile.account', {
                url: '/user',
                templateUrl: 'app/profile/profile-account.html',
                controller: 'ProfileAccountController',
                resolve: {
                    userInfo: ['userSvc', 'CacheFactory', function (userSvc, CacheFactory) {
                        // Clear all user-related caches before fetching fresh data
                        CacheFactory.get('UserCache') && CacheFactory.get('UserCache').removeAll();
                        CacheFactory.get('UserInfo') && CacheFactory.get('UserInfo').removeAll();
                        // Force fetch user info from API on each page load (bypass cache)
                        return userSvc.getUserInfo(true);
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            })
            .state('profile.billing', {
                url: '/billing',
                templateUrl: 'app/profile/profile-billing.html',
                controller: 'ProfileBillingController',
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'profileBilling');
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('profile_billing');
                        $translatePartialLoader.addPart('payment');
                        return $translate.refresh();
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            })
            // .state('profile.subscription', {
            //     url: '/subscription',
            //     templateUrl: 'app/profile/profile-subscription.html',
            //     controller: 'ProfileSubscriptionController',
            //     // lazyLoad: function ($transition$) {
            //     //     var lazyLoad = $transition$.injector().get('$ocLazyLoad'); $transition$.injector().get('$$animateJs');
            //     //     lazyLoad.inject('ngAnimate');
            //     //     lazyLoad.load([
            //     //         "/assets/css/main.payment.min.css?v=" + window.appVersion
            //     //     ]);
            //     //     return lazyLoad.load(
            //     //         {
            //     //             serie: false,
            //     //             files: [
            //     //                 "/assets/js/main.payment.min.js?v=" + window.appVersion
            //     //             ], insertBefore: '#last_script'
            //     //         }
            //     //     );
            //     // },
            //     resolve: {
            //
            //         translations: function ($translatePartialLoader, $translate) {
            //             $translatePartialLoader.addPart('profile_billing');
            //             return $translate.refresh();
            //         }
            //     },
            //     metaTags: {
            //         robots: 'noindex, nofollow'
            //     }
            // })
            // .state('profile.cards', {
            //     url: '/cards',
            //     templateUrl: 'app/profile/profile-cards.html',
            //     controller: 'ProfileCardsController',
            //     constrollerAs: 'vm',
            //     lazyLoad: function ($transition$) {
            //         var lazyLoad = $transition$.injector().get('$ocLazyLoad'); $transition$.injector().get('$$animateJs');
            //         lazyLoad.inject('ngAnimate');
            //         lazyLoad.load([
            //             "/assets/css/vendor.payment.min.css?v=" + window.appVersion,
            //             "/assets/css/main.payment.min.css?v=" + window.appVersion
            //         ]);
            //         return lazyLoad.load(
            //             {
            //                 serie: false,
            //                 files: [
            //                     "/assets/js/vendor.payment.min.js?v=" + window.appVersion,
            //                     "/assets/js/main.payment.min.js?v=" + window.appVersion,
            //                 ], insertBefore: '#last_script'
            //             }
            //         );
            //     },
            //     resolve: {
            //         cCart: ['paymentService', function (paymentService) {
            //             paymentService.clearCart();
            //         }],
            //
            //         translations: function ($translatePartialLoader, $translate) {
            //             $translatePartialLoader.addPart('profile_billing');
            //             $translatePartialLoader.addPart('payment');
            //             return $translate.refresh();
            //         }
            //     },
            //     metaTags: {
            //         robots: 'noindex, nofollow'
            //     }
            // })
            .state('profile.experience', {
                url: '/settings',
                templateUrl: 'app/profile/profile-experience.html',
                controller: 'ProfileExperienceController',
                resolve: {

                    HasPackage: ['guardSvc', function (guardSvc) {
                        return guardSvc.hasPackage();
                    }],

                    HasPlatinum: ['guardSvc', function (guardSvc) {
                        return guardSvc.hasPackage([
                            "platinum-package",
                            "premium-ee-package",
                            "terminal-premium-package",
                            "terminal-package",
                            "location-package",
                        ]);
                    }],

                    HasPremium: ['guardSvc', function (guardSvc) {
                        return guardSvc.hasPackage([
                            "eco-package",
                            "premium-package",
                            "premiumplus-package",
                            "pro-ee-package",
                            "flex-package",
                            "gold-package",
                            "terminal-flex-package",
                            "terminal-pro-package",
                            "platinum-package",
                            "premium-ee-package",
                            "terminal-premium-package",
                            "terminal-package",
                            "real-estate-package",
                            "location-package",
                        ]);
                    }],

                    HasRealEstate: ['guardSvc', function (guardSvc) {
                        return guardSvc.hasPackage([
                            "real-estate-package",
                            "location-package",
                        ]);
                    }],

                    HasLocation: ['guardSvc', function (guardSvc) {
                        return guardSvc.hasPackage(["location-package"]);
                    }],

                    HasAlarm: ['guardSvc', function (guardSvc) {
                        return guardSvc.hasPackage([
                            "premium-package",
                            "premiumplus-package",
                            "pro-ee-package",
                            "flex-package",
                            "gold-package",
                            "terminal-flex-package",
                            "terminal-pro-package",
                            "platinum-package",
                            "premium-ee-package",
                            "terminal-premium-package",
                            "terminal-package",
                            "real-estate-package"
                        ]);
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('profile_experience');
                        $translatePartialLoader.addPart('analysis_layout');
                        return $translate.refresh();
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            })
            .state('profile.company', {
                url: '/company',
                templateUrl: 'app/profile/profile-company.html',
                controller: 'ProfileCompanyController',
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'profileCompany');
                    }],
                    guard: [
                        "guardSvc",
                        "$window",
                        function (guardSvc, $window) {
                            if ($window.hasAllowance && $window.hasAllowance !== 'none')
                                return true;
                            else
                                return guardSvc.guardRoute([
                                    "real-estate-package",
                                    "location-package",
                                    "eco-package",
                                    'seller-lead-package',
                                    "premium-package",
                                    "premiumplus-package",
                                    "pro-ee-package",
                                    "flex-package",
                                    "gold-package",
                                    "terminal-flex-package",
                                    "terminal-pro-package",
                                    "terminal-package",
                                    "platinum-package",
                                    "premium-ee-package",
                                    "terminal-premium-package",
                                ]);
                        },
                    ],
                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('consultant_profile');
                        return $translate.refresh();
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            })
            .state('profile.userManagement', {
                url: '/user-management',
                templateUrl: 'app/profile/profile-user-management.html',
                controller: 'ProfileUserManagementController',
                resolve: {
                    guard: [
                        "guardSvc",
                        function (guardSvc) {
                            return guardSvc.guardRoute([
                                "terminal-package",
                                "terminal-flex-package",
                                "terminal-pro-package",
                                "terminal-premium-package"
                            ]);
                        },
                    ],
                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart('profile_user_management');
                        return $translate.refresh();
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow'
                }
            });

        // .state('profile.registrationManagement', {
        //     url: '/membership',
        //     templateUrl: 'app/profile/profile-registration-management.html',
        //     controller: 'ProfileRegistrationManagementController',
        //     resolve: {
        //
        //         trans: '$transition$',
        //
        //         langcode: function (trans) {
        //             document.cookie = 'langcode=' + trans.params().langcode;
        //         },
        //
        //         translations: function ($translatePartialLoader, $translate) {
        //             $translatePartialLoader.addPart('registration_management');
        //             return $translate.refresh();
        //         }
        //     },
        //     metaTags: {
        //         robots: 'noindex, nofollow'
        //     }
        // })
        // .state('profile.billingAdres', {
        //     url: '/billing-address',
        //     templateUrl: 'app/profile/profile-address.html',
        //     controller: 'ProfileAddressController',
        //     lazyLoad: function ($transition$) {
        //         var lazyLoad = $transition$.injector().get('$ocLazyLoad'); $transition$.injector().get('$$animateJs');
        //         lazyLoad.inject('ngAnimate');
        //         return lazyLoad.load(
        //             {
        //                 files: [
        //                     "/assets/js/main.payment.min.js?v=" + window.appVersion
        //                 ], insertBefore: '#last_script'
        //             }
        //         );
        //     },
        //     resolve: {
        //
        //         trans: '$transition$',
        //
        //         langcode: function (trans) {
        //             document.cookie = 'langcode=' + trans.params().langcode;
        //         },
        //
        //         translations: function ($translatePartialLoader, $translate) {
        //             $translatePartialLoader.addPart('profile_account');
        //             return $translate.refresh();
        //         }
        //     },
        //     metaTags: {
        //         robots: 'noindex, nofollow'
        //     }
        // })
        // .state('profile.creditCardEdit', {
        //     url: '/payment-options',
        //     template: '<credit-card-edit></credit-card-edit>',
        //     resolve: {
        //
        //         trans: '$transition$',
        //
        //         langcode: function (trans) {
        //             document.cookie = 'langcode=' + trans.params().langcode;
        //         },
        //
        //         translations: function ($translatePartialLoader, $translate) {
        //             $translatePartialLoader.addPart('profile_account');
        //             $translatePartialLoader.addPart('payment');
        //             return $translate.refresh();
        //         }
        //     },
        //     metaTags: {
        //         robots: 'noindex, nofollow'
        //     }
        // });

    }]);

})();
